
import styled from 'styled-components';
import backgroundImage from './../../../assets/background-header.webp';

interface ResponsiveProps {
  isDesktopFull?: boolean;
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}

export const MainContentWrapper = styled.main<ResponsiveProps>`
  //flex: 3;
  padding-top: 20px;
  //background-image: url(${backgroundImage});
  //background-size: cover;
  //background-repeat: no-repeat;
  //background-position: center;
  margin: ${({ isMobileMini, isMobileMedium, isMobileBig, isMiniNotebook, isDesktopOrLaptop, isDesktopFull }) =>    
  isMobileMini ? '0 0' 
  : isMobileMedium ? '0 0' 
  : isMobileBig ? '0 0px' 
  : isMiniNotebook ? '0 7px' 
  : isDesktopOrLaptop ? '0 15px' 
  : isDesktopFull ? '0 20px' 
  : '0 22px'};
`;
